import React from "react";

// Helper function to derive a valid ID from a given name
const deriveIdFromName = (name) => {
  return name.toLowerCase().replace(/ /g, "_");
};

const TeamMemberProfile = ({
  name,
  title,
  description,
  quote,
  socialLinks,
  memberType, // ⬅️ NEW: receive memberType
}) => {
  const id = deriveIdFromName(name);

  // Background image style for the avatar
  const avatarStyle = {
    backgroundImage: `url(img/team/avatars/${id}.jpg)`,
  };

  // Apply conditional class based on memberType
  const profileClass = memberType?.toLowerCase() === "honorary"
    ? "modal__profile modal__profile--honorary"
    : "modal__profile modal__profile--core";

  return (
    <div id={id} data-uk-modal>
      <div className={`${profileClass} modal uk-modal-dialog uk-margin-auto-vertical`}>
        <div className="modal__cover uk-cover-container">
          <img
            src="img/team/covers/alley.jpg"
            alt="alleyway background"
            data-uk-cover
          />
        </div>
        <div className="modal__content">
          <div
            className="modal__avatar boxshadow uk-background-cover"
            style={avatarStyle}
            data-uk-img
          ></div>
          <h3 className="modal__profile__title uk-modal-title uk-text-center">
            {name}
          </h3>
          <div className="modal__profile__subtitle uk-text-center">{title}</div>
          <p className="uk-text-left">
            {description}
            <br />
            {quote && <span className="quote">{quote}</span>}
          </p>
          <div className="social social--modal">
            <ul className="social__list uk-list uk-align-center">
              {socialLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    <span className={link.icon}></span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <button
          className="modal__close uk-modal-close-outside"
          type="button"
          data-uk-close
        ></button>
      </div>
    </div>
  );
};

export default TeamMemberProfile;
